import { render, staticRenderFns } from "./CoursesTab.vue?vue&type=template&id=5d8d63d5"
import script from "./CoursesTab.vue?vue&type=script&lang=js"
export * from "./CoursesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports